module.exports = __webpack_public_path__ + "static/media/preview.9859c601.png";